/* eslint-disable react/no-unknown-property */
import React from 'react'
interface SSCERecordUploadProps {
    ninValidated: boolean;
    boxErrorMessage: string;
    displayForm: boolean;
    sittings: number;
    subArray: string[];
    handleFirstSittingChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
    handleSecondSittingChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
    validateFormRow: () => boolean;
    loadAssert: any
}
export default function SSCERecordUpload (props: SSCERecordUploadProps) {
  return (
              <section
            className={`card border-0   rounded${
              !props.ninValidated || props.boxErrorMessage ? ' d-none' : ''
            } ${!props.displayForm ? ' d-none' : 'd-block'} ${
              props.validateFormRow() === false && 'd-none'
            }`}
            id='doc'
          >
            <div className='bg-white'>
              <div className='section-container'>
                <div className='section-item-container'></div>
             <div className='section-item-container'></div>
                <div className='section-item-container p-1'>
                  <h3 className='sub-heading__pinfo'>Input Olevel Results</h3>
                </div>
                <div className='section-item-container'></div>
              </div>
              <div className='row m-0 p-0'>
                <div
                  className={
                    [1, 0].includes(props.sittings)
                      ? 'col-md-6 p-3 bg-white text-center offset-md-3'
                      : 'col-md-6 p-3 bg-white text-center'
                  }
                >
                  {/* <div className="col-md-6 p-3 bg-white text-center"> */}
                  <div>
                    <h4>First Sitting</h4>
                    <table className='table'>
                      <tbody>
                        <tr>
                          <td>
                            <select
                              className='form-control'
                              name='subject1'
                              // placeholder='subject 1'
                              onChange={props.handleFirstSittingChange}
                            >
                              <option>--select subject--</option>
                              {props.subArray
                                .slice(0, 1)
                                .map((res: any, index: any) => {
                                  return <option key={index}>{res}</option>;
                                })}
                            </select>
                          </td>

                          <td>
                            <select
                              className='form-control'
                              // placeholder='grade 1'
                              name='grade1'
                              onChange={props.handleFirstSittingChange}
                            >
                              <option>--select grade-</option>
                              <option>A1</option>
                              <option>B2</option>
                              <option>B3</option>
                              <option>C4</option>
                              <option>C5</option>
                              <option>C6</option>
                              <option>D7</option>
                              <option>E8</option>
                              <option>F9</option>
                            </select>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <select
                              className='form-control'
                              name='subject2'
                              // placeholder='subject 2'
                              onChange={props.handleFirstSittingChange}
                            >
                              <option>--select subject--</option>
                              {props.subArray
                                .slice(1, 2)
                                .map((res: any, index: any) => {
                                  return <option key={index}>{res}</option>;
                                })}
                            </select>
                          </td>

                          <td>
                            <select
                              className='form-control'
                              name='grade2'
                              // placeholder='grade 2'
                              onChange={props.handleFirstSittingChange}
                            >
                              <option>--select grade-</option>
                              <option>A1</option>
                              <option>B2</option>
                              <option>B3</option>
                              <option>C4</option>
                              <option>C5</option>
                              <option>C6</option>
                              <option>D7</option>
                              <option>E8</option>
                              <option>F9</option>
                            </select>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <select
                              className='form-control'
                              name='subject3'
                              // placeholder='subject 3'
                              onChange={props.handleFirstSittingChange}
                            >
                              <option>--select subject--</option>
                              {props.subArray.map((res: any, index: any) => {
                                return <option key={index}>{res}</option>;
                              })}
                            </select>
                          </td>

                          <td>
                            <select
                              className='form-control'
                              name='grade3'
                              // placeholder='grade 3'
                              onChange={props.handleFirstSittingChange}
                            >
                              <option>--select grade-</option>
                              <option>A1</option>
                              <option>B2</option>
                              <option>B3</option>
                              <option>C4</option>
                              <option>C5</option>
                              <option>C6</option>
                              <option>D7</option>
                              <option>E8</option>
                              <option>F9</option>
                            </select>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <select
                              className='form-control'
                              name='subject4'
                              // placeholder='subject 4'
                              onChange={props.handleFirstSittingChange}
                            >
                              <option>--select subject--</option>
                              {props.subArray.map((res: any, index: any) => {
                                return <option key={index}>{res}</option>;
                              })}
                            </select>
                          </td>

                          <td>
                            <select
                              className='form-control'
                              name='grade4'
                              // placeholder='grade 4'
                              onChange={props.handleFirstSittingChange}
                            >
                              <option>--select grade-</option>
                              <option>A1</option>
                              <option>B2</option>
                              <option>B3</option>
                              <option>C4</option>
                              <option>C5</option>
                              <option>C6</option>
                              <option>D7</option>
                              <option>E8</option>
                              <option>F9</option>
                            </select>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <select
                              className='form-control'
                              name='subject5'
                              // placeholder='subject 5'
                              onChange={props.handleFirstSittingChange}
                            >
                              <option>--select subject--</option>
                              {props.subArray.map((res: any, index: any) => {
                                return <option key={index}>{res}</option>;
                              })}
                            </select>
                          </td>

                          <td>
                            <select
                              className='form-control'
                              name='grade5'
                              // placeholder='grade 5'
                              onChange={props.handleFirstSittingChange}
                            >
                              <option>--select grade-</option>
                              <option>A1</option>
                              <option>B2</option>
                              <option>B3</option>
                              <option>C4</option>
                              <option>C5</option>
                              <option>C6</option>
                              <option>D7</option>
                              <option>E8</option>
                              <option>F9</option>
                            </select>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <select
                              className='form-control'
                              name='subject6'
                              // placeholder='subject 6'
                              onChange={props.handleFirstSittingChange}
                            >
                              <option>--select subject--</option>
                              {props.subArray.map((res: any, index: any) => {
                                return <option key={index}>{res}</option>;
                              })}
                            </select>
                          </td>

                          <td>
                            <select
                              className='form-control'
                              name='grade6'
                              // placeholder='grade 6'
                              onChange={props.handleFirstSittingChange}
                            >
                              <option>--select grade-</option>
                              <option>A1</option>
                              <option>B2</option>
                              <option>B3</option>
                              <option>C4</option>
                              <option>C5</option>
                              <option>C6</option>
                              <option>D7</option>
                              <option>E8</option>
                              <option>F9</option>
                            </select>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <select
                              className='form-control'
                              name='subject7'
                              // placeholder='subject 7'
                              onChange={props.handleFirstSittingChange}
                            >
                              <option>--select subject--</option>
                              {props.subArray.map((res: any, index: any) => {
                                return <option key={index}>{res}</option>;
                              })}
                            </select>
                          </td>

                          <td>
                            <select
                              className='form-control'
                              name='grade7'
                              // placeholder='grade 7'
                              onChange={props.handleFirstSittingChange}
                            >
                              <option>--select grade-</option>
                              <option>A1</option>
                              <option>B2</option>
                              <option>B3</option>
                              <option>C4</option>
                              <option>C5</option>
                              <option>C6</option>
                              <option>D7</option>
                              <option>E8</option>
                              <option>F9</option>
                            </select>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <select
                              className='form-control'
                              name='subject8'
                              // placeholder='subject 8'
                              onChange={props.handleFirstSittingChange}
                            >
                              <option>--select subject--</option>
                              {props.subArray.map((res: any, index: any) => {
                                return <option key={index}>{res}</option>;
                              })}
                            </select>
                          </td>

                          <td>
                            <select
                              className='form-control'
                              // placeholder='grade 8'
                              name='grade8'
                              onChange={props.handleFirstSittingChange}
                            >
                              <option>--select grade-</option>
                              <option>A1</option>
                              <option>B2</option>
                              <option>B3</option>
                              <option>C4</option>
                              <option>C5</option>
                              <option>C6</option>
                              <option>D7</option>
                              <option>E8</option>
                              <option>F9</option>
                            </select>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <select
                              className='form-control'
                              name='subject9'
                              // placeholder='subject 9'
                              onChange={props.handleFirstSittingChange}
                            >
                              <option>--select subject--</option>
                              {props.subArray.map((res: any, index: any) => {
                                return <option key={index}>{res}</option>;
                              })}
                            </select>
                          </td>

                          <td>
                            <select
                              className='form-control'
                              name='grade9'
                              // placeholder='grade 9'
                              onChange={props.handleFirstSittingChange}
                            >
                              <option>--select grade-</option>
                              <option>A1</option>
                              <option>B2</option>
                              <option>B3</option>
                              <option>C4</option>
                              <option>C5</option>
                              <option>C6</option>
                              <option>D7</option>
                              <option>E8</option>
                              <option>F9</option>
                            </select>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div
                  className={
                    props.sittings === 2
                      ? 'col-md-6 p-3 bg-white text-center'
                      : 'd-none col-md-6 p-3 bg-white text-center'
                  }
                >
                  <div className='card'>
                    <div className='card'>
                      <div>
                        <h4>Second Sitting</h4>
                        <table className='table'>
                          <tbody>
                            <tr>
                              <td>
                                <select
                                  className='form-control'
                                  name='subject1'
                                  // placeholder='subject 1'
                                  onChange={props.handleSecondSittingChange}
                                >
                                  <option>--select subject--</option>
                                  {props.subArray
                                    .slice(0, 1)
                                    .map((res: any, index: any) => {
                                      return <option key={index}>{res}</option>;
                                    })}
                                </select>
                              </td>

                              <td>
                                <select
                                  className='form-control'
                                  // placeholder='grade 1'
                                  name='grade1'
                                  onChange={props.handleSecondSittingChange}
                                >
                                  <option>--select grade-</option>
                                  <option>A1</option>
                                  <option>B2</option>
                                  <option>B3</option>
                                  <option>C4</option>
                                  <option>C5</option>
                                  <option>C6</option>
                                  <option>D7</option>
                                  <option>E8</option>
                                  <option>F9</option>
                                </select>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <select
                                  className='form-control'
                                  name='subject2'
                                  // placeholder='subject 2'
                                  onChange={props.handleSecondSittingChange}
                                >
                                  <option>--select subject--</option>
                                  {props.subArray
                                    .slice(1, 2)
                                    .map((res: any, index: any) => {
                                      return <option key={index}>{res}</option>;
                                    })}
                                </select>
                              </td>

                              <td>
                                <select
                                  className='form-control'
                                  name='grade2'
                                  // placeholder='grade 2'
                                  onChange={props.handleSecondSittingChange}
                                >
                                  <option>--select grade-</option>
                                  <option>A1</option>
                                  <option>B2</option>
                                  <option>B3</option>
                                  <option>C4</option>
                                  <option>C5</option>
                                  <option>C6</option>
                                  <option>D7</option>
                                  <option>E8</option>
                                  <option>F9</option>
                                </select>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <select
                                  className='form-control'
                                  name='subject3'
                                  // placeholder='subject 3'
                                  onChange={props.handleSecondSittingChange}
                                >
                                  <option>--select subject--</option>
                                  {props.subArray.map(
                                    (res: any, index: any) => {
                                      return <option key={index}>{res}</option>;
                                    }
                                  )}
                                </select>
                              </td>

                              <td>
                                <select
                                  className='form-control'
                                  name='grade3'
                                  // placeholder='grade 3'
                                  onChange={props.handleSecondSittingChange}
                                >
                                  <option>--select grade-</option>
                                  <option>A1</option>
                                  <option>B2</option>
                                  <option>B3</option>
                                  <option>C4</option>
                                  <option>C5</option>
                                  <option>C6</option>
                                  <option>D7</option>
                                  <option>E8</option>
                                  <option>F9</option>
                                </select>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <select
                                  className='form-control'
                                  name='subject4'
                                  // placeholder='subject 4'
                                  onChange={props.handleSecondSittingChange}
                                >
                                  <option>--select subject--</option>
                                  {props.subArray.map(
                                    (res: any, index: any) => {
                                      return <option key={index}>{res}</option>;
                                    }
                                  )}
                                </select>
                              </td>

                              <td>
                                <select
                                  className='form-control'
                                  name='grade4'
                                  // placeholder='grade 4'
                                  onChange={props.handleSecondSittingChange}
                                >
                                  <option>--select grade-</option>
                                  <option>A1</option>
                                  <option>B2</option>
                                  <option>B3</option>
                                  <option>C4</option>
                                  <option>C5</option>
                                  <option>C6</option>
                                  <option>D7</option>
                                  <option>E8</option>
                                  <option>F9</option>
                                </select>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <select
                                  className='form-control'
                                  name='subject5'
                                  // placeholder='subject 5'
                                  onChange={props.handleSecondSittingChange}
                                >
                                  <option>--select subject--</option>
                                  {props.subArray.map(
                                    (res: any, index: any) => {
                                      return <option key={index}>{res}</option>;
                                    }
                                  )}
                                </select>
                              </td>

                              <td>
                                <select
                                  className='form-control'
                                  name='grade5'
                                  // placeholder='grade 5'
                                  onChange={props.handleSecondSittingChange}
                                >
                                  <option>--select grade-</option>
                                  <option>A1</option>
                                  <option>B2</option>
                                  <option>B3</option>
                                  <option>C4</option>
                                  <option>C5</option>
                                  <option>C6</option>
                                  <option>D7</option>
                                  <option>E8</option>
                                  <option>F9</option>
                                </select>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <select
                                  className='form-control'
                                  name='subject6'
                                  // placeholder='subject 6'
                                  onChange={props.handleSecondSittingChange}
                                >
                                  <option>--select subject--</option>
                                  {props.subArray.map(
                                    (res: any, index: any) => {
                                      return <option key={index}>{res}</option>;
                                    }
                                  )}
                                </select>
                              </td>

                              <td>
                                <select
                                  className='form-control'
                                  name='grade6'
                                  // placeholder='grade 6'
                                  onChange={props.handleSecondSittingChange}
                                >
                                  <option>--select grade-</option>
                                  <option>A1</option>
                                  <option>B2</option>
                                  <option>B3</option>
                                  <option>C4</option>
                                  <option>C5</option>
                                  <option>C6</option>
                                  <option>D7</option>
                                  <option>E8</option>
                                  <option>F9</option>
                                </select>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <select
                                  className='form-control'
                                  name='subject7'
                                  // placeholder='subject 7'
                                  onChange={props.handleSecondSittingChange}
                                >
                                  <option>--select subject--</option>
                                  {props.subArray.map(
                                    (res: any, index: any) => {
                                      return <option key={index}>{res}</option>;
                                    }
                                  )}
                                </select>
                              </td>

                              <td>
                                <select
                                  className='form-control'
                                  name='grade7'
                                  // placeholder='grade 7'
                                  onChange={props.handleSecondSittingChange}
                                >
                                  <option>--select grade-</option>
                                  <option>A1</option>
                                  <option>B2</option>
                                  <option>B3</option>
                                  <option>C4</option>
                                  <option>C5</option>
                                  <option>C6</option>
                                  <option>D7</option>
                                  <option>E8</option>
                                  <option>F9</option>
                                </select>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <select
                                  className='form-control'
                                  name='subject8'
                                  // placeholder='subject 8'
                                  onChange={props.handleSecondSittingChange}
                                >
                                  <option>--select subject--</option>
                                  {props.subArray.map(
                                    (res: any, index: any) => {
                                      return <option key={index}>{res}</option>;
                                    }
                                  )}
                                </select>
                              </td>

                              <td>
                                <select
                                  className='form-control'
                                  // placeholder='grade 8'
                                  name='grade8'
                                  onChange={props.handleSecondSittingChange}
                                >
                                  <option>--select grade-</option>
                                  <option>A1</option>
                                  <option>B2</option>
                                  <option>B3</option>
                                  <option>C4</option>
                                  <option>C5</option>
                                  <option>C6</option>
                                  <option>D7</option>
                                  <option>E8</option>
                                  <option>F9</option>
                                </select>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <select
                                  className='form-control'
                                  name='subject9'
                                  // placeholder='subject 9'
                                  onChange={props.handleSecondSittingChange}
                                >
                                  <option>--select subject--</option>
                                  {props.subArray.map(
                                    (res: any, index: any) => {
                                      return <option key={index}>{res}</option>;
                                    }
                                  )}
                                </select>
                              </td>

                              <td>
                                <select
                                  className='form-control'
                                  name='grade9'
                                  // placeholder='grade 9'
                                  onChange={props.handleSecondSittingChange}
                                >
                                  <option>--select grade-</option>
                                  <option>A1</option>
                                  <option>B2</option>
                                  <option>B3</option>
                                  <option>C4</option>
                                  <option>C5</option>
                                  <option>C6</option>
                                  <option>D7</option>
                                  <option>E8</option>
                                  <option>F9</option>
                                </select>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
  )
}
